import axios from "axios";
import { useMemo } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { imageFileUploadUrl } from "../../js/server";

function Editor(props) {
  const apiPostImage = async (data) => {
    try {
      const result = await axios.post(imageFileUploadUrl, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      return result;
    } catch (err) {
      console.error(err);
    }
  };

  function imageHandler() {
    const input = document.createElement("input");
    const boardkind = props.boardKind;

    input.setAttribute("type", "file");
    input.setAttribute("accept", "image/*");
    input.click();

    input.onchange = async () => {
      const file = input.files[0];
      const formData = new FormData();
      formData.append("image", file);
      formData.append("boardname", boardkind);

      // Save current cursor state
      const range = this.quill.getSelection(true);

      // Insert temporary loading placeholder image
      this.quill.insertEmbed(
        range.index,
        "image",
        `${window.location.origin}/images/loaders/placeholder.gif`
      );

      // Move cursor to right side of image (easier to continue typing)
      this.quill.setSelection(range.index + 1);

      const res = await apiPostImage(formData); // API post, returns image location as string e.g. 'http://www.example.com/images/foo.png'
      let imageUrl = "";
      if (res.data.result === "OK") {
        imageUrl = res.data.data;
      }

      // Remove placeholder image
      this.quill.deleteText(range.index, 1);

      // Insert uploaded image
      // this.quill.insertEmbed(range.index, 'image', res.body.image);
      this.quill.insertEmbed(range.index, "image", imageUrl);
    };
  }

  const modules = useMemo(
    () => ({
      toolbar: {
        container: [
          [
            { header: "1" },
            { header: "2" },
            { header: [3, 4, 5, 6] },
            { font: [] },
          ],
          [{ size: [] }],
          ["bold", "italic", "underline", "strike", "blockquote"],
          [{ color: [] }, { background: [] }],
          [{ list: "ordered" }, { list: "bullet" }],
          ["link", "image", "video"],
          ["clean"],
          ["code-block"],
        ],
        handlers: {
          image: imageHandler,
        },
      },
    }),
    // eslint-disable-next-line
    []
  );

  return (
    <ReactQuill
      theme="snow"
      value={props.contents || ""}
      onChange={props.setContents}
      modules={modules}
      placeholder={props.placeholder}
    />
  );
}

export default Editor;
